// extracted by mini-css-extract-plugin
module.exports = {"listContainer":"TextBullets_listContainer__UxtQo","item":"TextBullets_item__ZvJUy"};